import { Col, Form, Input, Row, Select } from "antd";
import type { RdRawMaterialRequisitionFormValue } from "../../type";
import ModalSectionHeader from "@/components/ui/ModalSectionHeader";
import { MaterialFileFormFields } from "@/components/commonFormItems/MaterialFileFormFields";
import styles from "@/asserts/styles/formSection.module.less";
import { useFormEditable } from "../../hooks/useFormEditable";
import { useTranslation } from "react-i18next";

export const SpecialRequirementFormFields = () => {
  const { t } = useTranslation("purchaseRequestManagement");
  const { t: tCommon } = useTranslation("common");
  const form = Form.useFormInstance<RdRawMaterialRequisitionFormValue>();
  const isSuggestedSupplier = Form.useWatch("isSuggestedSupplier", form);

  const { isMainFormDisabled } = useFormEditable();
  return (
    <div className={styles.formSection}>
      <ModalSectionHeader title={t("特别要求")} />

      <div className={styles.sectionBody}>
        <Row gutter={49}>
          <Col span={24}>
            <Form.Item<RdRawMaterialRequisitionFormValue>
              name="pharmacopoeia"
              label={t("药典/标准")}
              rules={[
                {
                  required: true,
                  message: t("请输入"),
                },
              ]}
            >
              <Input.TextArea rows={2} placeholder={t("请输入")} />
            </Form.Item>
          </Col>
        </Row>

        <MaterialFileFormFields
          fieldName="qualityStandard"
          label={t("指定建议的药典或质量标准如有")}
          required={false}
          hiddenRemove={isMainFormDisabled}
        />

        <Row gutter={49}>
          <Col span={24}>
            <Form.Item<RdRawMaterialRequisitionFormValue>
              name="batchRequirements"
              label={t("批次要求")}
              rules={[
                {
                  required: true,
                  message: t("请输入"),
                },
              ]}
            >
              <Input.TextArea rows={2} placeholder={t("请输入")} />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={49}>
          <Col span={8}>
            <Form.Item<RdRawMaterialRequisitionFormValue>
              name="isSuggestedSupplier"
              label={t("是否指定供应商")}
              rules={[
                {
                  required: true,
                  message: t("请选择"),
                },
              ]}
            >
              <Select
                placeholder={t("请选择")}
                options={[
                  { label: tCommon("是"), value: 1 },
                  { label: tCommon("否"), value: 0 },
                ]}
              />
            </Form.Item>
          </Col>

          {isSuggestedSupplier === 1 && (
            <>
              <Col span={8}>
                <Form.Item<RdRawMaterialRequisitionFormValue>
                  name="suggestedSupplierName"
                  label={t("指定建议供应商名称")}
                >
                  <Input placeholder={t("请输入")} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item<RdRawMaterialRequisitionFormValue>
                  name="suggestedReason"
                  label={t("指定建议原因")}
                >
                  <Input.TextArea rows={2} placeholder={t("请输入")} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item<RdRawMaterialRequisitionFormValue>
                  name="requirementsRemarks"
                  label={t("备注说明")}
                >
                  <Input.TextArea rows={2} placeholder={t("请输入")} />
                </Form.Item>
              </Col>
            </>
          )}
        </Row>

        {isSuggestedSupplier === 1 && (
          <MaterialFileFormFields
            fieldName="suggestedSupplierCoa"
            label={t("指定建议供应商COA")}
            required={false}
            hiddenRemove={isMainFormDisabled}
          />
        )}
        <MaterialFileFormFields
          fieldName="requirementsFiles"
          label={t("其他附件")}
          required={false}
          hiddenRemove={isMainFormDisabled}
        />
      </div>
    </div>
  );
};
